import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IconSpriteModule } from 'ng-svg-icon-sprite';
import { setTabState } from '../../../+state/configurator/configurator.actions';
import { ConfiguratorFacade } from '../../../+state/configurator/configurator.facade';
import { CardComponent } from '../../../card/card.component';
import { listAnimation } from '../../../utils/animations/list.animations';
import { CurrencyFormatterPipe } from '../../../utils/currency-formatter.pipe';
import { ConfiguratorImageComponent } from '../../components/configurator-image/configurator-image.component';
import { AddCurrencyPipe } from '../../utils/add-currency.pipe';
import { DataByIdPipe } from '../../utils/data-by-id.pipe';
import { SortByPricePipe } from '../../utils/sort-by-price.pipe';

@Component({
    selector: 'ncg-configurator-interior',
    animations: [listAnimation],
    template: `
        <ng-container *ngIf="configuratorFacade.routerQueryParams$ | async as params">
            <div
                class="container"
                *ngIf="configuratorFacade.variant$ | async as variant"
                [@listAnimation]="variant.commercialColourOptionInteriorIds?.length">
                <div class="configurator__cards">
                    <ng-container *ngIf="configuratorFacade.model$ | async as model">
                        <ng-container
                            *ngFor="
                                let interiorId of variant.commercialColourOptionInteriorIds
                                    | sortByPrice: model.commercialColourOptionsInterior : 'CommercialColourOptionRetailSellingPrice' : 'asc'
                                    | async
                            ">
                            <ncg-card
                                class="configurator__card"
                                [selected]="interiorId === params.interior"
                                contentClass="configurator__card-content content"
                                *ngIf="model.commercialColourOptionsInterior?.[interiorId] as interior">
                                <ncg-configurator-image
                                    [fields]="interior?.resourcePackShot?.[0]?.fields"
                                    sizes="300px"
                                    card-image></ncg-configurator-image>
                                <h2 class="configurator__label card-label">
                                    <a
                                        class="configurator__font-weight--emphasis configurator__link-cover"
                                        (click)="configuratorFacade.dispatch(setTabState({ tab: 'interior', tabState: 'visited' }))"
                                        [routerLink]="[]"
                                        [replaceUrl]="true"
                                        [queryParams]="{ interior: interior.id }"
                                        queryParamsHandling="merge">
                                        {{ interior.fields | dataById: 'CommercialColourOptionMarketingTitle' }}
                                    </a>
                                </h2>
                                <p
                                    class="configurator__text"
                                    *ngIf="interior.fields | dataById: 'CommercialColourOptionMarketingDescription' as description">
                                    {{ description }}
                                </p>
                                <div class="configurator__price price" *ngIf="configuratorFacade.showPrices$ | async">
                                    {{
                                        interior.fields
                                            | dataById: ('CommercialColourOptionRetailSellingPrice' | addCurrency | async)
                                            | currencyFormatter
                                    }}
                                </div>
                            </ncg-card>
                        </ng-container>
                    </ng-container>
                </div>
                <div class="configurator__legal">
                    <!-- Not needed datawise, but the list animation does not trigger without this evaluation -->
                    <p *ngIf="variant.fields">
                        <strong>{{ variant.fields | dataById: 'VariantMarketingTitle' }}.</strong>
                        {{ variant.fields | dataById: 'VariantLegalText' }}<br />
                        {{ variant.fields | dataById: 'VariantLegalTextConfigurator' }}
                    </p>
                </div>
            </div>
        </ng-container>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    styles: [
        `
            .price {
                text-align: end;
            }
            .card-label {
                margin-bottom: 0.5em;
            }
        `,
    ],
    imports: [
        CommonModule,
        CardComponent,
        DataByIdPipe,
        CurrencyFormatterPipe,
        RouterModule,
        IconSpriteModule,
        ConfiguratorImageComponent,
        AddCurrencyPipe,
        SortByPricePipe,
    ],
})
export class ConfiguratorInteriorComponent {
    public readonly setTabState = setTabState;
    constructor(public readonly configuratorFacade: ConfiguratorFacade) {}
}
